import { environment } from '../../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseResponse } from 'ccc-commons/dist/core';

@Injectable({
  providedIn: 'root'
})
export class GeneralConfigurationService {
  apiUrl = environment.apiUrl + '/configuration/general';
  public config: any = null;

  constructor(private http: HttpClient) {}

  getAllConfig(): Observable<BaseResponse<any>> {
    return this.http.get<BaseResponse<any>>(this.apiUrl);
  }

 /**
   * Handles the account service feed.
   */
  public async resolverData() {
    if (!this.config) {
      const userRequest = await this.http.get<BaseResponse<any>>(
        `${this.apiUrl}`
      ).toPromise();
      this.config = userRequest.body;
      return this.config;
    }
    return this.config;
  }
}
